// eslint-disable-next-line no-unused-vars
import { Promise as PromisePolyFill } from 'core-js';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
